import PropTypes from "prop-types"

import { makeShouldUseNewWizardExp } from "areas/product/jewlr"
import { SkuIcon } from "areas/product/wizard-options/components"

const metalMap = {
  CER: {
    skuColor: "CE",
    value: "CE",
  },
  SS14KYP: {
    skuColor: "YGP",
    value: "14K",
  },
  SS18KYP: {
    skuColor: "YGP",
    value: "18K",
  },
  SSRGP: {
    skuColor: "R",
    value: "R",
  },
  SST18KYT: {
    skuColor: "YGP",
    value: "18K",
  },
  VERMY: {
    skuColor: "V",
    value: "V",
  },
}

const MetalIcon = ({ as, className, metal }) => {
  const shouldUseNewWizardExp = makeShouldUseNewWizardExp()
  const mappedMetal = metalMap[metal.value]
  const skuColor = mappedMetal ? mappedMetal.skuColor : metal.imageKey.slice(-1)
  const metalValue = mappedMetal ? mappedMetal.value : metal.icon_text

  return (
    <SkuIcon
      as={as}
      className={className}
      shouldUseNewWizardExp={shouldUseNewWizardExp}
      skuColor={skuColor}
    >
      {metalValue}
    </SkuIcon>
  )
}

MetalIcon.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string,
  metal: PropTypes.object,
}

export default MetalIcon
